import { api } from '../api.service'
import { responseMessage } from '../util'


export const putOpen = async (token) => {
  try {
    var response = await api.put('app-delivery/open', {}, {
      headers: {
        'x-access-token': token,
      }
    },
    )
    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}

//
export const getOpen = async ( data) => {
  try {
    var response = await api.get('app-delivery/open', {
      params: data
    },
    )
    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}



export const getSale = async (data) => {
  try {
    var response = await api.get('app-delivery/sale',
      {
        params: data
      })

    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}



export const putConfirmarLeo = async (token, pedido) => {
  try {
    var response = await api.put('app-delivery/confirmar', pedido,
      {
        headers: {
          'x-access-token': token,
        },
      })

    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}

export const postPedido = async (token, pedido) => {
  try {
    var response = await api.post('app-delivery/pedido', pedido,
      {
        headers: {
          'x-access-token': token,
        },

      })

    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}



export const getCampanhasResgateItens = async (token) => {
  try {
    var response = await api.get('app-delivery/campanha/itens-resgate',
      {
        headers: {
          'x-access-token': token,
        },

      })

    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}

export const getLoja = async (data) => {
  try {
    var response = await api.get('app-delivery', {
      params: data
    })
    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}


export const getMenu = async (data) => {
  try {
    var response = await api.get('app-delivery/menu', {
      params: data
    })
    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}

export const postLogin = async (data, banco) => {
  try {
    var response = await api.post('app-delivery/login', data, {
      params: banco
    })
    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}

export const postCadastro = async (data, banco) => {
  try {
    var response = await api.post('app-delivery/cadastro', data, {
      params: banco
    })
    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}

export const getPedidos = async (token) => {
  try {
    var response = await api.get('app-delivery/pedidos', {
      headers: {
        'x-access-token': token,
      },
    })
    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}

export const putCadastro = async (token, data) => {
  try {
    var response = await api.put('app-delivery/cadastro', data, {
      headers: {
        'x-access-token': token,
      }
    })
    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}


export const postEndereco = async (token, data) => {
  try {
    var response = await api.post('app-delivery/endereco', data, {
      headers: {
        'x-access-token': token,
      }
    })
    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}


export const getEnderecos = async (token) => {
  try {
    var response = await api.get('app-delivery/enderecos', {
      headers: {
        'x-access-token': token,
      }
    })
    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}


export const putEnderecoIsprincipal = async (token, data) => {
  try {
    var response = await api.put('app-delivery/endereco/isprincipal', data, {
      headers: {
        'x-access-token': token,
      }
    })
    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}

export const deleteEndereco = async (token, data) => {
  try {
    var response = await api.put('app-delivery/endereco/delete', data, {
      headers: {
        'x-access-token': token,
      }
    })
    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}


export const getFidelidade = async (token) => {
  try {
    var response = await api.get('app-delivery/fidelidade', {
      headers: {
        'x-access-token': token,
      }
    })
    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}


export const getLocalizarCupom = async (token, data) => {
  try {
    var response = await api.get('app-delivery/localizar-cupons', {
      headers: {
        'x-access-token': token,
      },
      params: data
    })
    return response.data
  } catch (error) {
    throw new Error(responseMessage(error.message))
  }
}


